<div class="form">
  <ldw-settings-form [captionWidth]="230" [settings]="settings"></ldw-settings-form>
</div>
